module.exports = __webpack_public_path__ + "img/image32.ef910928.jpg";